import { Component, ElementRef, Renderer2, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';

import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';


@Component({
    templateUrl: 'integrations.html',
    standalone: false
})

export class EmployerIntegrationsPage implements OnInit {

  readonly desktopWidthContent: string = scrollContentWidth.LARGE;
  loaded: boolean;
  linkToken: any;

  
  boundOpenMergeLink = this.openMergeLink.bind(this);

constructor(
    private elementRef: ElementRef,
    private http: HttpClient,
    private navCtrl: CustomNavController,
    private renderer2: Renderer2,
    public windowService: WindowService
  ) {}

  async ngOnInit() {
    this.loaded = false;
    await this.mockGetPublicKey();
    this.mockInitMerge();
    this.loaded = true;
  }

  mockInitMerge() {
    // Mock initialization - no actual MergeLink
  }

  mockSuccess(_public_token: string) {
    // Mock success handler
    const _mockAccountToken = `mock_account_token_${  Date.now()}`;
  }

  async mockGetPublicKey() {
    return new Promise<void>((resolve) => {
      // Mock the API call
      setTimeout(() => {
        this.linkToken = `mock_link_token_${  Date.now()}`;
        resolve();
      }, 1000); // Simulate API delay
    });
  }

  openMergeLink() {
    // Mock the link opening - simulate success
    setTimeout(() => {
      const mockPublicToken = `mock_public_token_${  Date.now()}`;
      this.mockSuccess(mockPublicToken);
    }, 2000); // Simulate user interaction delay
  }
}
